import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_005.jpg';
page.images = [
  {
    imageId: 'page005_zoom0',
    rectangle: {
      x: 28,
      y: 1617,
      width: 1600,
      height: 960,
    },
    imageSrc: 'images/page005/005 2.jpg',
  },
  {
    imageId: 'page005_zoom1',
    rectangle: {
      x: 118,
      y: 77,
      width: 1500,
      height: 880,
    },
    imageSrc: 'images/page005/005 1.jpg',
  },
];

// page.games = [
//   {
//     id: 'page007_game2',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 0,
//     },
//   },
//   {
//     id: 'page009_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 100,
//     },
//   },
//   {
//     id: 'page009_game2',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 200,
//     },
//   },
//   {
//     id: 'page009_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 300,
//     },
//   },
//   {
//     id: 'page011_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 400,
//     },
//   },
//   {
//     id: 'page011_game5',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 500,
//     },
//   },
//   {
//     id: 'page013_game5',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 600,
//     },
//   },
//   {
//     id: 'page016_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 700,
//     },
//   },
//   {
//     id: 'page017_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 800,
//     },
//   },
//   {
//     id: 'page017_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 900,
//     },
//   },
//   {
//     id: 'page017_game12',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1000,
//     },
//   },
//   {
//     id: 'page019_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1100,
//     },
//   },
//   {
//     id: 'page019_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1200,
//     },
//   },
//   {
//     id: 'page021_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1300,
//     },
//   },
//   {
//     id: 'page021_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1400,
//     },
//   },
//   {
//     id: 'page024_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1500,
//     },
//   },
//   {
//     id: 'page025_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1600,
//     },
//   },
//   {
//     id: 'page026_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1700,
//     },
//   },
//   {
//     id: 'page029_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1800,
//     },
//   },
//   {
//     id: 'page029_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1900,
//     },
//   },
//   {
//     id: 'page030_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2000,
//     },
//   },
//   {
//     id: 'page031_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2100,
//     },
//   },
//   {
//     id: 'page031_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2200,
//     },
//   },
//   {
//     id: 'page034_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2300,
//     },
//   },
// ];
// page.scratchPad = [
//   // {
//   //   id: 'page003_game1',
//   //   icon: 'ikonaBrudnopis',
//   //   color: '#FF000000',
//   //   pos: {
//   //     x: RIGHT,
//   //     y: 198,
//   //   },
//   //   item: {
//   //     id: 'page003_game1',
//   //   },
//   //   rectangle: {
//   //     id: 'page003_rect1',
//   //   },
//   // },
//   {
//     id: 'page003_game0',
//     icon: 'ikonaBrudnopis',
//     color: '#FF000000',
//     pos: {
//       x: RIGHT,
//       y: 988,
//     },
//     item: {
//       id: 'page003_game0',
//     },
//     rectangle: {
//       id: 'page003_rect0',
//     },
//   },
// ];
// page.rectangle = [
//   {
//     id: 'page003_rect0',
//
//     tooltip: '',
//     color: '#FF000000',
//     linked: ['page003_game0'],
//     x: 116,
//     y: 988,
//     width: 1717,
//     height: 1417,
//   },
//   // {
//   //   id: 'page003_rect1',
//   //
//   //   tooltip: '',
//   //   color: '#FF000000',
//   //   linked: ['page003_game1'],
//   //   x: 116,
//   //   y: 198,
//   //   width: 1713,
//   //   height: 780,
//   // },
// ];
export default page;
